import {
  DirectionsRenderer,
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useCallback, useEffect, useMemo, useState } from "react";

function Map({ directions, allDetails, activeMarker, setActiveMarker }) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDNw1dSoxiOLYvanqCDowSaLhK7XIc8E2Q",
  });

  const [map, setMap] = useState(null);

  const center = useMemo(
    () => ({
      lat: 48.856614,
      lng: 2.3522219,
    }),
    []
  );

  const containerStyle = useMemo(
    () => ({
      width: "40%",
      height: "100%",
      borderRadius: "0.5rem",
    }),
    []
  );

  const imgStyle = useMemo(
    () => ({
      width: "150px",
    }),
    []
  );

  const options = useMemo(
    () => ({
      disableDefaultUI: false,
      clickableIcons: false,
    }),
    []
  );

  const onLoad = useCallback((map) => setMap(map), []);

  useEffect(() => {
    if (map && allDetails.length > 1) {
      const bounds = new window.google.maps.LatLngBounds();
      allDetails.forEach((marker) => {
        bounds.extend(marker.geocode);
      });
      map.fitBounds(bounds);
    } else if (map) {
      map.setZoom(14);
    }
  }, [map, allDetails]);

  const handleActiveMarker = (id) => {
    if (id === activeMarker) {
      return;
    }
    setActiveMarker(id);
  };

  return (
    isLoaded && (
      <GoogleMap
        onLoad={onLoad}
        mapContainerStyle={containerStyle}
        options={options}
        center={allDetails[allDetails.length - 1]?.geocode || center}
        zoom={17}
      >
        {directions && <DirectionsRenderer directions={directions} />}
        {allDetails.length > 0 &&
          allDetails.map(({ id, details, geocode }) => (
            <Marker
              key={id}
              position={geocode}
              onClick={() => handleActiveMarker(id)}
            >
              {activeMarker === id && (
                <InfoWindow
                  onCloseClick={() => setActiveMarker(null)}
                  position={geocode}
                >
                  <div className="p-2 text-center w-80">
                    {typeof details.photos != "undefined" && (
                      <img
                        src={details.photos?.[0].getUrl()}
                        style={imgStyle}
                        alt={details.name}
                        className="w-full mx-auto"
                      />
                    )}
                    <h3 className="text-lg px-4 font-bold">{details.name}</h3>
                    <span className="italic">{details.formatted_address}</span>
                    <p className="text-[0.8rem] my-1 ">
                      {details.opening_hours?.weekday_text?.map((day) => (
                        <p key={day}>{day}</p>
                      ))}
                    </p>
                    {details.rating && <p>Rating : {details.rating}</p>}
                    {typeof details.website != "undefined" && (
                      <a
                        href={details.website}
                        target="blank"
                        className="text-sm text-white font-bold hover:underline bg-blue-400 px-2 rounded-lg"
                        style={{ display: "inline-block", marginTop: "10px" }}
                      >
                        Website
                      </a>
                    )}
                  </div>
                </InfoWindow>
              )}
            </Marker>
          ))}
      </GoogleMap>
    )
  );
}

export default Map;
